import { render, staticRenderFns } from "./TextAttribute.vue?vue&type=template&id=4d6b3e72"
import script from "./TextAttribute.vue?vue&type=script&lang=js"
export * from "./TextAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports